'use strict';

const analyticsSignUpCategory = 'SignUp';
const analyticsSignUpAction = 'SignedUp';

export default function auth($q, $http, $state, $window, session, utils, userModel, temporaryUser, analytics, join, localStorage) {
  'ngInject';

  const getCurrency = () => localStorage.get('currency');

  function setSessionData(data) {
    session.set(data);
    userModel.initItem(data.userId);
  }

  function handleResponse(response, resolve) {
    var responseData = response.data;
    var sessionData = {
      accessToken: responseData.token,
      userId: responseData.userId
    };
    var isNewUser = responseData.status === 'registered';

    setSessionData(sessionData);

    if (isNewUser) {
      analytics.track(analyticsSignUpAction, {
        category: analyticsSignUpCategory,
        value: '0.00',
        currency: 'USD'
      });

      if (typeof fbq !== 'undefined') {
        fbq('track', 'CompleteRegistration');
      }

      // Linkedin pixel for registration
      var linkedinEl = document.createElement("div");
      linkedinEl.innerHTML = '<img height="1" width="1" style="display:none;" alt="" src="https://px.ads.linkedin.com/collect/?pid=3819929&conversionId=5396625&fmt=gif" />';
      document.body.appendChild(linkedinEl);
    }

    temporaryUser.remove();
    $q.resolve(userModel.itemPromise)
      .then(() => {

        // Send user id to SegmentIO
        analytics.identify(String(sessionData.userId));

        // Send user id to Sentry
        // $raven.setUserContext({id: sessionData.userId});
      })
      .then(() => {
        resolve({ isNewUser: isNewUser });
      });
  }

  function login(path, data) {
    return new $q(function (resolve, reject) {
      var httpPromise = $http.post(utils.getApiUrl('/authentication' + (path || '')), data);

      httpPromise
        .then(response => {
          if (response.data.status === 'error') {
            alert(response.data.message);
            handleResponse(response, resolve);
          } else {
            handleResponse(response, resolve);
          }
        })
        .catch(reject);
    });
  }

  return {
    socialLogin: function (networkName, accessToken, socialId) {
      var data = {
        accessToken: accessToken,
        socialId: socialId,
        currency: getCurrency()
      };

      return login('/' + networkName, data);
    },

    login: login,

    signUpWithEmail: function (data) {
      if (join.becomeGuide) {
        data.guideStatus = 'notVerified';
      }
      data.currency = getCurrency();

      return new $q((resolve, reject) => {
        $http.post(utils.getApiUrl('authentication/profile_registration'), data)
          .then(response => {
            var tempUserData = response.data;

            temporaryUser.setData(tempUserData);
            resolve(tempUserData);
          })
          .catch(reject);
      });
    },

    signInWithEmail: function (data) {
      return login('/profile_login', data);
    },

    activateAccount: function (data) {
      var isGuide;

      return new $q(function (resolve, reject) {
        const requestConfig = {
          params: data
        };

        $http.get(utils.getApiUrl('authentication/profile_activation'), requestConfig)
          .then(response => {
            isGuide = Boolean(response.data.guideStatus);

            handleResponse(response, resolve);
          })
          .then(() => {
            if (isGuide) {
              $state.go('settings');
            }
          })
          .catch(reject);
      });
    },

    resendActivationEmail: function (data) {
      return new $q(function (resolve, reject) {
        $http.post(utils.getApiUrl('authentication/profile_registration_resend'), data)
          .then(response => {
            var tempUserData = temporaryUser.getData();

            angular.extend(tempUserData, response.data);
            temporaryUser.setData(tempUserData);
            resolve();
          })
          .catch(reject);
      });
    },

    sendPasswordResetLink: function (email) {
      var data = {
        email: email
      };

      return new $q(function (resolve, reject) {
        $http.post(utils.getApiUrl('reset_password/remind'), data)
          .then(resolve)
          .catch(reject);
      });
    },

    manualLogin(data) {
      return $q((resolve) => {
        handleResponse(data, resolve);
      });
    },

    setSessionData: setSessionData
  };
}



// WEBPACK FOOTER //
// ./app/src/services/auth.js